import { createAction } from '@reduxjs/toolkit';
import { RequestError } from 'types';
import { State, Callback } from './types';

export const fetchStations = createAction('stations/fetch', (callback?: Callback<unknown, void>) => ({
  payload: undefined,
  meta: { callback },
}));

export const fetchedStations = createAction('stations/fetched', (data?: State['data'], error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export default {
  fetchStations,
};
